// Import action types related to Gujarat Samagra City data
import {
  GUJARATSAMAGRACITY_ARE_LOADING,
  GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS,
  GUJARATSAMAGRACITY_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the GujaratSamagraCityReducer
const initialState = {
  data: [],
  loading: true,
  error: [], // Initialize error as null for better error handling
};

// Reducer function to handle Gujarat Samagra City-related actions and update state accordingly
export function GujaratSamagraCityReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching Gujarat Samagra City data
    case GUJARATSAMAGRACITY_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when Gujarat Samagra City data is being fetched
    case GUJARATSAMAGRACITY_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when Gujarat Samagra City data is successfully fetched
    case GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.GujaratSamagraCity, // Update the data state with the fetched Gujarat Samagra City data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
